export default [
  {
    path: "AgentVersion",
    name: "AgentVersion",
    meta: {
      title: "代理商最新进销存数据"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/AgentVersion/index.vue")
  },
  {
    path: "AgentVersionNew",
    name: "AgentVersionNew",
    meta: {
      title: "代理商阶段进销存数据"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/AgentVersionNew/index.vue")
  },
  {
    path: "AgencyActivation",
    name: "AgencyActivation",
    meta: {
      title: "代理商激活数据"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/AgencyActivation/index.vue")
  },
  {
    path: "AgentOrdering",
    name: "AgentOrdering",
    meta: {
      title: "代理商订货数据"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/AgentOrdering/index.vue")
  },
  {
    path: "Subscription",
    name: "Subscription",
    meta: {
      title: "订阅卡使用记录"
    },
    component: () =>
      import("@/views/Home/DataCenter/BusinessData/Subscription/index.vue")
  },
  {
    path: "ReportManage/region_campus_sub_achievement",
    name: "region_campus_sub_achievement",
    meta: {
      title: "货款返还对账明细报表"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/RegionCampusSubAchievement/index.vue")
  },
  {
    path: "ReportManage/sy_region_cash_back",
    name: "sy_region_cash_back",
    meta: {
      title: "货款返还对账明细报表"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/SyRegionCashBack/index.vue")
  },
  {
    path: "ReportManage/campus_sub_stat_detail",
    name: "campus_sub_stat_detail",
    meta: {
      title: "订阅卡返还记录"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/CampusSubStatDetail/index.vue")
  },
  {
    path: "ReportManage/sy_region_sub_fee_rebate",
    name: "sy_region_sub_fee_rebate",
    meta: {
      title: "订阅费返佣对账明细报表"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/SyRegionSubFeeRebate/index.vue")
  },
  {
    path: "agentCrossActivateCreditLimit",
    name: "agentCrossActivateCreditLimit",
    meta: {
      title: "经销商跨区域激活额度"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/AgentCrossActivateCreditLimit/index.vue")
  },
  {
    path: "financialStatements",
    name: "financialStatements",
    meta: {
      title: "设备价值明细报表"
    },
    component: () =>
      import("@/views/Home/DataCenter/RegionData/FinancialStatements/index.vue")
  },
]  
